class PpdFormUpsellComponent extends HTMLElement {
  constructor() {
    super();
    // The data is pulled from snippets/pdp-form-upsell-component.liquid
    this.data = PDP_FORM_UPSELL_COMPONENT_DATA;
  }

  // Called when the element is connected to the document's DOM.
  connectedCallback() {
    this.initItems();
    this.initItemsEventLister();
    this.initComponents();
    this.initCustomEventListeners();
    this.loadInfo();
  }

  // Called when the element is disconnected from the document's DOM.
  disconnectedCallback() {
    this.addToCartBtn.removeEventListener(
      "click",
      this.formUpsellAddToCart.bind(this)
    );
    this.removeEventListener(
      "pdp-upsell-item-size-change",
      this.eventHandlerSize.bind(this)
    );

    this.removeEventListener(
      "pdp-upsell-item-bundle-box-change",
      this.controllerBundleBoxComponent.bind(this)
    );

    this.removeEventListener(
      "pdp-upsell-item-quantity-change",
      this.eventHandlerQuantity.bind(this)
    );

    this.removeEventListener(
      "pdp-upsell-item-add-on-change",
      this.controllerAddOnComponent.bind(this)
    );

    this.removeEventListener(
      "pdp-form-upsell-variant-info-change",
      this.eventHandlerVariantInfoChanged.bind(this)
    );
  }

  // Initializes item references for the upsell component.
  initItems() {
    this.variant = this.querySelector(`#variant`);
    this.variantPrice = this.querySelector(`#variant-price`);
    this.variantComparePrice = this.querySelector(`#variant-compare-price`);
    this.mappedSize = this.querySelector(`#mapped-size`);
    this.topProductPrice = document.querySelector(
      ".product__info-wrapper .price-item--regular"
    );
    this.topProductComparePrice = document.querySelector(
      ".product__info-wrapper .price-item--sale"
    );
    this.upsellTotal = this.querySelector("#pdp-upsell-total");
    this.upsellComparePriceTotal = this.querySelector(
      "#pdp-upsell-compare-price-total"
    );
    this.addToCartBtn = this.querySelector("#pdp-upsell-add-to-cart");
    this.klaviyoBtn = this.querySelector("#pdp-upsell-klaviyo-btn");
    this.sizeWarningMessage = this.querySelector(
      "#module-size-warning-message"
    );
  }

  // Initializes component references for the upsell component.
  initComponents() {
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartCountBubble = document.querySelector("#cart-icon-bubble");
    this.sizeSelector = document.querySelector("pdp-upsell-item-size");
    this.bundleBoxItem = document.querySelector("pdp-upsell-item-bundle-box");
    this.quantityItem = document.querySelector("pdp-upsell-item-quantity");
    this.addOnComponents = Array.from(
      document.querySelectorAll("pdp-upsell-item-add-on")
    );
  }

  // Initializes event listeners for upsell items.
  initItemsEventLister() {
    this.addToCartBtn.addEventListener(
      "click",
      this.formUpsellAddToCart.bind(this)
    );
  }

  // Initializes custom event listeners for the upsell component.
  initCustomEventListeners() {
    this.addEventListener(
      "pdp-upsell-item-size-change",
      this.eventHandlerSize.bind(this)
    );

    this.addEventListener(
      "pdp-upsell-item-bundle-box-change",
      this.controllerBundleBoxComponent.bind(this)
    );

    this.addEventListener(
      "pdp-upsell-item-quantity-change",
      this.eventHandlerQuantity.bind(this)
    );

    this.addEventListener(
      "pdp-upsell-item-add-on-change",
      this.controllerAddOnComponent.bind(this)
    );

    this.addEventListener(
      "pdp-form-upsell-variant-info-change",
      this.eventHandlerVariantInfoChanged.bind(this)
    );
  }

  // Loads initial information for the upsell component.
  loadInfo() {
    const { mainProduct } = this.data;
    const variant = mainProduct.variants[0];
    this.updateVariantInfo(variant, "", false);
    this.updateUpsellTotalPriceView(variant.price, variant.comparePrice, true);
    this.checkVariantAvailability(false, variant);
  }

  /**
   * Handles the event when the size is changed.
   * @param {Event} event - The size change event.
   */
  eventHandlerSize(event) {
    const { detail } = event;
    this.sizeWarningGuardClause(false);

    if (this.bundleBoxItem) {
      this.controllerBundleBoxComponent(false, detail);
      return;
    }

    this.controllerSizeComponent(detail);

    if (this.addOnComponents) {
      this.controllerAddOnComponent(false, true);
    }
  }

  /**
   * Handles the event when the quantity is changed.
   * @param {Event} event - The quantity change event.
   */
  eventHandlerQuantity(event) {
    const { quantity } = event.detail;
    this.updateUpsellTotalPrice(quantity);

    if (this.addOnComponents) {
      this.controllerAddOnComponent();
    }
  }

  /**
   * Handles the event when the variant information is changed.
   * @param {Event} event - The variant info change event.
   */
  eventHandlerVariantInfoChanged(event) {
    this.updateUpsellTotalPrice();
    this.checkVariantAvailability(event, false);
  }

  /**
   * Controls the size component based on the provided details.
   * @param {Object} detail - The size details.
   */
  controllerSizeComponent(detail) {
    const { size, mappedSize } = detail;
    const variant = this.data.mainProduct.variants.find(
      (el) => el.size === size
    );
    this.updateVariantInfo(variant, mappedSize);
  }

  /**
   * Controls the bundle box component based on the event or size details.
   * @param {Event|boolean} event - The bundle box change event.
   * @param {Object|boolean} sizeDetails - The size details.
   */
  controllerBundleBoxComponent(event = false, sizeDetails = false) {
    let handle, isUpgradedSystem;
    const getBundleBoxVariant = (isUpgradedSystem, handle, size) => {
      let variant;
      if (isUpgradedSystem === "true") {
        variant = this.data.bundleBox
          .find((el) => el.handle === handle)
          ?.variants.find((el) => el.size === size);
      }
      if (isUpgradedSystem === "false") {
        variant = this.data.mainProduct.variants.find((el) => el.size === size);
      }
      return variant;
    };

    if (event) {
      const {
        detail: { isBundleUpgradedSystem, bundleBoxHandle },
      } = event;
      isUpgradedSystem = isBundleUpgradedSystem;
      handle = bundleBoxHandle;
    } else {
      const { bundleBoxHandle, isBundleUpgradedSystem } =
        this.bundleBoxItem.getSelectedBundleBox();
      handle = bundleBoxHandle;
      isUpgradedSystem = isBundleUpgradedSystem;
    }

    const { size, mappedSize } =
      sizeDetails || this.sizeSelector.getCurrentSize();

    const variant = getBundleBoxVariant(isUpgradedSystem, handle, size);

    this.updateUpsellTotalAndCompareTotalVariantIdView(variant.id);

    this.updateVariantInfo(variant, mappedSize);
  }

  /**
   * Controls the add-on component based on the provided events.
   * @param {Event|boolean} addOnComponentEvent - The add-on component event.
   * @param {Event|boolean} sizeComponentEvent - The size component event.
   */
  controllerAddOnComponent(
    addOnComponentEvent = false,
    sizeComponentEvent = false
  ) {
    let addOnComponentsTotal, addOnComponentsTotalComparePrice;

    if (addOnComponentEvent) {
      const addOnComponent = addOnComponentEvent.target.closest(
        "pdp-upsell-item-add-on"
      );
      const { size: currentSize } = this.sizeSelector.getCurrentSize();
      const checkedElements = addOnComponent.getCheckedItems();

      if (checkedElements.length) {
        const addOnItemsTotal = checkedElements.map((checkedEl) => {
          const addOnProduct = this.data.addOnSettings.find(
            (el) => el.handle === checkedEl.addonItemHandle
          );
          const addOnVariant = addOnProduct.variants.find(
            (el) => el.size === currentSize
          );

          const { price, comparePrice } = addOnVariant;

          return {
            total: price * checkedEl.quantity,
            totalComparePrice: comparePrice * checkedEl.quantity,
          };
        });

        const addOnTotal = addOnItemsTotal.reduce(
          (accumulator, currentValue) => {
            return accumulator + currentValue.total;
          },
          0
        );

        const addOnComparePriceTotal = addOnItemsTotal.reduce(
          (accumulator, currentValue) => {
            return accumulator + currentValue.totalComparePrice;
          },
          0
        );
        addOnComponent.setAddOnTotals(addOnTotal, addOnComparePriceTotal);
      } else {
        addOnComponent.setAddOnTotals(0, 0);
      }
    }

    if (sizeComponentEvent) {
      const { size } = this.sizeSelector.getCurrentSize();
      const variantsAvailability = this.data.addOnSettings.map((product) => {
        const variant = product.variants.find(
          (variant) => variant.size === size
        );
        return {
          productHandle: product.handle,
          isVariantAvailable: variant ? variant.isAvailable : false,
        };
      });

      this.addOnComponents.forEach((el) =>
        el.checkVariantAvailability(variantsAvailability)
      );
    }

    const addOnComponentsTotalArray = this.addOnComponents.map((el) =>
      el.getAddOnTotals()
    );

    addOnComponentsTotal = addOnComponentsTotalArray
      .map((el) => el.total)
      .reduce((concat, current) => concat + current, 0);

    addOnComponentsTotalComparePrice = addOnComponentsTotalArray
      .map((el) => el.totalComparePrice)
      .reduce((concat, current) => concat + current, 0);

    const { upsellTotal, upsellTotalComparePrice } = this.getUpsellTotal();

    const newUpsellTotal = upsellTotal + addOnComponentsTotal;
    const newUpsellTotalComparePrice =
      upsellTotalComparePrice + addOnComponentsTotalComparePrice;

    this.updateUpsellTotalPriceView(
      newUpsellTotal,
      newUpsellTotalComparePrice,
      false
    );
  }

  /**
   * Updates the variant information displayed in the upsell component.
   * @param {Object} variant - The variant data.
   * @param {string} mappedSize - The mapped size.
   * @param {boolean} [dispatchEvent=true] - Whether to dispatch the variant info change event.
   */
  updateVariantInfo(variant, mappedSize, dispatchEvent = true) {
    const { id, price, comparePrice } = variant;
    this.variant.value = id;
    this.variantPrice.value = price;
    this.variantComparePrice.value = comparePrice;
    this.mappedSize.value = mappedSize;

    if (dispatchEvent) {
      this.dispatchEvent(
        new CustomEvent("pdp-form-upsell-variant-info-change", {
          detail: {
            variant,
          },
        })
      );
    }
  }

  /**
   * Updates the total price for the upsell items based on the quantity.
   * @param {number} quantity - The quantity of the item.
   */
  updateUpsellTotalPrice(quantity) {
    const qty = quantity || this.quantityItem.getQuantity();
    const variantPrice = parseFloat(this.variantPrice.value);
    const comparePrice = parseFloat(this.variantComparePrice.value);

    const total = (qty * variantPrice).toFixed(2);
    const totalComparePrice = (qty * comparePrice).toFixed(2);

    this.updateUpsellTotalPriceView(total, totalComparePrice, true);
  }

  /**
   * Updates the variant ID view for the upsell total and compare total.
   * @param {string} variantId - The ID of the variant to update.
   */
  updateUpsellTotalAndCompareTotalVariantIdView(variantId) {
    this.upsellTotal.dataset.variantId = variantId;
    if (this.upsellComparePriceTotal) {
      this.upsellComparePriceTotal.dataset.variantId = variantId;
    }
    // (Optional) Update the price from the top PDP
    this.topProductPrice.dataset.variantId = variantId;
    if (this.topProductComparePrice) {
      this.topProductComparePrice.dataset.variantId = variantId;
    }
  }

  /**
   * Updates the view of the total price for the upsell items.
   * @param {number} upsellTotal - The total upsell price.
   * @param {number} upsellComparePriceTotal - The total compare price for the upsell items.
   * @param {boolean} [updateValue=false] - Whether to update the value attribute.
   */
  updateUpsellTotalPriceView(
    upsellTotal,
    upsellComparePriceTotal,
    updateValue = false
  ) {
    this.upsellTotal.innerHTML = this.formatMoney(upsellTotal);
    if (updateValue) this.upsellTotal.dataset.value = upsellTotal;

    if (this.upsellComparePriceTotal) {
      this.upsellComparePriceTotal.innerHTML = this.formatMoney(
        upsellComparePriceTotal
      );
      if (updateValue)
        this.upsellComparePriceTotal.dataset.value = upsellComparePriceTotal;
    }
  }

  /**
   * Retrieves the total upsell price and compare price.
   * @returns {Object} The total upsell price and compare price.
   */
  getUpsellTotal() {
    const upsellTotal = parseFloat(this.upsellTotal.dataset.value);
    const upsellTotalComparePrice = this.upsellComparePriceTotal
      ? parseFloat(this.upsellComparePriceTotal.dataset.value)
      : 0;

    return { upsellTotal, upsellTotalComparePrice };
  }

  /**
   * Retrieves the variant information for the upsell item.
   * @returns {Object} The variant information.
   */
  getVariantInfo() {
    return {
      id: this.variant.value,
      mappedSize: this.mappedSize.value,
      quantity: this.quantityItem.getQuantity(),
    };
  }

  /**
   * Checks the availability of the current variant.
   * @param {Event|boolean} event - The variant availability check event.
   * @param {Object|boolean} variant - The variant data.
   */
  checkVariantAvailability(event, variant) {
    const currentVariant = event ? event.detail.variant : variant;
    const { isAvailable } = currentVariant;

    this.klaviyoBtn.dataset.showKlaviyo = !isAvailable ? true : false;
    this.addToCartBtn.disabled = !isAvailable ? true : false;
  }

  // Adds the upsell item to the cart.

  async formUpsellAddToCart() {
    const { isCurrentSizeNull } = this.sizeSelector.getCurrentSize();
    if (isCurrentSizeNull) {
      this.sizeWarningGuardClause(true);
      return;
    }

    const variant = this.getVariantInfo();

    const formData = {
      items: [
        {
          id: variant.id,
          quantity: variant.quantity,
          ...(variant.mappedSize && {
            properties: { "User Height": variant.mappedSize },
          }),
        },
      ],
    };

    const cartNote = variant.mappedSize
      ? `user Height: ${variant.mappedSize}`
      : false;

    this.setLoadingToAddToCart(true);

    try {
      const addResponse = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await addResponse.json();
      if (!addResponse.ok) throw new Error(`${data.description}`);

      if (this.addOnComponents) await this.addToCartAddOnItems();

      if (cartNote) this.addCartNote(cartNote);

      // Tracking the Added to Cart event for klaviyo analytics
      if (window._learnq) {
        window._learnq.push(["track", "Added to Cart", variant]);
      }
    } catch (error) {
      console.log(
        `❌ PDP Form Upsell Component | formUpsellAddToCart | ${error.message}`
      );
    } finally {
      this.openAndPopulateCart();
      this.setLoadingToAddToCart(false);
      this.resetValues();
    }
  }

  // Adds the add-on items to the cart.
  async addToCartAddOnItems() {
    const { size: currentSize } = this.sizeSelector.getCurrentSize();
    const checkedElements = this.addOnComponents.flatMap((component) =>
      component.getCheckedItems()
    );
    if (!checkedElements.length) return;

    const variantsToAdd = checkedElements.map(
      ({ addonItemHandle, quantity }) => {
        const addOnProduct = this.data.addOnSettings.find(
          (el) => el.handle === addonItemHandle
        );
        const addOnVariant = addOnProduct.variants.find(
          (el) => el.size === currentSize
        );

        const { id } = addOnVariant;

        return {
          id,
          quantity,
        };
      }
    );

    const formData = {
      items: variantsToAdd,
    };

    try {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.log(`❌ PdpFormUpsellComponent | addToCartAddOnItems | ${error}`);
    }

    return;
  }

  /**
   * Adds a note to the cart.
   * @param {string} note - The note to add to the cart.
   */
  addCartNote(note) {
    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ note }),
      });
    } catch (error) {
      console.log(
        `❌ PDP Form Upsell Component | addCartNote | ${error.message}`
      );
    }
  }

  // Resets the values of the upsell component.
  resetValues() {
    this.sizeSelector.resetValue();
    this.bundleBoxItem?.resetValue();
    this.quantityItem?.resetValue();

    this.addOnComponents?.forEach((el) => el.resetValues());

    this.loadInfo();
    this.mappedSize.value = "";
  }

  /**
   * Sets the loading state for the add to cart button.
   * @param {boolean} flag - Whether to set the button to loading state.
   */
  setLoadingToAddToCart(flag) {
    this.addToCartBtn.disabled = flag;
    this.addToCartBtn.innerHTML = flag ? "ADDING..." : "ADD TO CART";
  }

  /**
   * Displays or hides the size warning message.
   * @param {boolean} flag - Whether to display the size warning message.
   */
  sizeWarningGuardClause(flag) {
    this.sizeWarningMessage.dataset.showModuleSizeWarningMessage = flag;
    this.addToCartBtn.disabled = flag;
  }
  /**
   * Utility function to format money based on the user country
   * @param {float|number|string} amount - The money amount to format
   * @returns {string} - The formatted money string
   */
  formatMoney(amount) {
    // Ensure the amount is a number
    const numAmount = parseFloat(amount);

    // Check if the conversion to a number was successful
    if (isNaN(numAmount)) {
      console.error("Invalid amount provided:", amount);
      return "";
    }

    const fixedAmount = numAmount.toFixed(2);
    if (window.Shopify && window.Shopify.country) {
      if (window.Shopify.country === "CA") {
        return `$${fixedAmount} CAD`;
      }
    }
    return `$${fixedAmount}`;
  }

  async openAndPopulateCart() {
    // Fetch the updated cart drawer content from the server
    const response = await fetch("/cart");
    const responseText = await response.text();

    // Parse the fetched HTML response into a DOM document
    const newCartMarkup = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    // Update cart icon bubble
    const newCartIconBubbleMarkup =
      newCartMarkup.querySelector("#cart-icon-bubble");
    this.cartCountBubble.innerHTML = newCartIconBubbleMarkup.innerHTML;

    // Remove empty class
    this.cartDrawer.classList.remove("is-empty");

    // Get new cart drawer markup
    const newCartDrawerMarkup = newCartMarkup.querySelector("#CartDrawer");

    // Replace markup
    this.cartDrawer
      .querySelector("#CartDrawer")
      .replaceWith(newCartDrawerMarkup);

    // Open cart
    this.cartDrawer.open();

    this.cartDrawer.hideInstallmentsCTA();
  }
}
customElements.define("pdp-form-upsell", PpdFormUpsellComponent);
